import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { Button, Input, Modal } from '@/design-system'

export interface RenameGalleryModalProps {
  open: boolean
  initialName: string
  onClose: () => void
  onSubmit: (name: string) => void
}

export function RenameGalleryModal({ open, initialName, onClose, onSubmit }: RenameGalleryModalProps) {
  const [name, setName] = useState(initialName)

  useEffect(() => {
    if (open) setName(initialName)
  }, [open, initialName])

  const submit = () => {
    const trimmed = name.trim()
    if (!trimmed) return
    onSubmit(trimmed)
    onClose()
  }

  return (
    <Modal open={open} onClose={onClose} title='Rename gallery'>
      <Box mb={3}>
        <Input
          autoFocus
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder='Gallery name'
          inputProps={{ maxLength: 60 }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') submit()
          }}
        />
      </Box>
      <Box display='flex' justifyContent='flex-end' gap={1.5}>
        <Button variant='ghost' onClick={onClose}>
          Cancel
        </Button>
        <Button variant='primary' onClick={submit} disabled={!name.trim()}>
          Save
        </Button>
      </Box>
    </Modal>
  )
}
